export enum TaskFilterType {
  CONSULTATION = 'AC',
  EXAM = 'AE',
  ATTENDANCE = 'AT',
  SURGERY = 'AS',
}